<template>
    <v-layout row style="width:100%;height:100%;">
        <v-flex d-flex md10 style="padding-top:5%;padding-bottom:5%;">
            <dx-bullet
                style="width:100%;height:100%;"
                :show-target="false"
                :show-zero-level="true"
                :value="value"
                :start-scale-value="minValue"
                :end-scale-value="maxValue"
                :color="color">            
                <dx-margin
                    :top="5"
                    :bottom="0"
                    :left="5"
                />
                <dx-tooltip
                    :enabled="false"/>
            </dx-bullet>
        </v-flex>
        <v-flex d-flex md2 style="display:flex;justify-content:center;align-items:center;">
            {{value}}
        </v-flex>        
    </v-layout>
</template>

<script>
    import {
        DxBullet,
        DxFont,
        DxMargin,
        DxSize,
        DxTooltip
    } from 'devextreme-vue/bullet';

    export default {
    components: {
        DxBullet,
        DxFont,
        DxMargin,
        DxSize,
        DxTooltip
    },
    props: {
        value: Number, 
        maxValue: Number,
        minValue:Number,
        color:String
    },
    data() {
        return {
        };
    },
    mounted()
    {
        
    }
    };
</script>
<style scoped>

</style>

<style>
.dx-datagrid .dx-data-row > td.bullet {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
